import {validateSeniorForm, validateStep1, validateStep2} from '../utils/validation';
import {JobPostingRequest} from "../interface/JobPostingRequest";
import {defaultAlert} from "../utils/alert";
import {SeniorFormData} from "../interface/SeniorFormData";


interface JobQuestion {
    questionCode: string;
    questionName: string;
    questionType: 'O' | 'T' | 'M';
    required?: boolean;
    options?: { optionName: string }[];
}

export const useFormValidation = () => {
    const validate = (errors: string[]): boolean => {
        if (errors.length > 0) {
            defaultAlert(errors[0]);
            return false;
        }
        return true;
    };

    return {
        validateJobApplyFirstPage: (formData: JobPostingRequest) =>
            validate(validateStep1(formData)),

        validateJobApplySecondPage: (
            formData: JobPostingRequest,
            questionList: JobQuestion[],
            answers: Record<string, string | { selection: string; text: string }>
        ) =>
            validate(validateStep2(formData, questionList, answers)),

        validateSeniorFormPage: (formData: SeniorFormData) =>
            validate(validateSeniorForm(formData))
    };
};